import { ChangeOrderPaymentStatusByMarkerRequest } from '@/Api/MpOrdersMarking/Requests';
import { DateFormatType, OrderMarker, OrderStatusFilterGroups } from '@/Enums';
import { useForm } from '@/Hooks/useFormWrapper';
import { useRequired } from '@/Hooks/Validation';
import { purchasesPageAsyncActions } from '@/Pages/Purchases/services';
import { salesPageActions } from '@/Pages/Sales/services';
import { dateTimeUtils } from '@/Utils/DateTimeUtils';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/Redux/ConfigureStore';
import { changePaymentAsyncActions } from '../services/asyncActions';

type FormData = ChangeOrderPaymentStatusByMarkerRequest;

export const useAllNotPaidForm = (orderIds: number[], isSalesPage: boolean, onClose: () => void) => {
  const dispatch: AppDispatch = useDispatch();

  const methods = useForm<FormData>({
    defaultValues: {
      orderMarker: OrderMarker.Paid,
      orderIds,
      paymentDate: dateTimeUtils.getCurrentDateTime(DateFormatType.LOCAL_DATE_TIME),
    },
  });

  const required = useRequired();

  const submit = useCallback(
    (data: FormData) => {
      dispatch(
        changePaymentAsyncActions.changePaymentStatus({
          ...data,
          paymentDate: dateTimeUtils.localStringToUtcString(data?.paymentDate),
        }),
      ).then(() => {
        if (isSalesPage) {
          dispatch(
            salesPageActions.removeOrdersFromStateByCurrentFilters({
              orderIds: data.orderIds,
              filters: OrderStatusFilterGroups.NotPaidGroup,
            }),
          );
        } else {
          dispatch(purchasesPageAsyncActions.getPurchasesWithCurrentFilters());
        }

        onClose();
      });
    },
    [onClose, isSalesPage, dispatch],
  );

  return {
    methods,
    submit: methods.handleSubmit(submit),
    rules: {
      required,
    },
  };
};
